import React from 'react';
import { Item } from './styled';
import HierarchyInnerItem from './HierarchyInnerItem';

const HierarchyItem = (props) => {
  const { activated, docType, guid, humanId, itemsCount, children, showChildren } = props;

  return (
    <Item>
      <div className="item-contents">
        <div className="item-header">
          <span className="document-title">
            {docType} {humanId} Строк: [{itemsCount}]
            {activated ? (
              <i className="fe-thumbs-up active" />
            ) : (
              <i className="fe-thumbs-down not-active" />
            )}
          </span>
        </div>
      </div>
      {showChildren && children && children.length !== 0 && (
        <div className="children-inner-item">
          {children
            .sort((a, b) => a.humanId - b.humanId)
            .map((item, index) => {
              return <HierarchyInnerItem props={item} key={index} />;
            })}
        </div>
      )}
    </Item>
  );
};

export default HierarchyItem;
